import "vant/es/tab/style";
import _Tab from "vant/es/tab";
import "vant/es/tabs/style";
import _Tabs from "vant/es/tabs";
import "vant/es/list/style";
import _List from "vant/es/list";
import "vant/es/collapse/style";
import _Collapse from "vant/es/collapse";
import "vant/es/collapse-item/style";
import _CollapseItem from "vant/es/collapse-item";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "E:\\work\\\u521B\u5947\\\u95EE\u5377\\answer-h5-new\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "E:\\work\\\u521B\u5947\\\u95EE\u5377\\answer-h5-new\\node_modules\\core-js\\modules\\es.promise.js";
import "E:\\work\\\u521B\u5947\\\u95EE\u5377\\answer-h5-new\\node_modules\\core-js\\modules\\es.object.assign.js";
import "E:\\work\\\u521B\u5947\\\u95EE\u5377\\answer-h5-new\\node_modules\\core-js\\modules\\es.promise.finally.js";
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'normalize.css';
import 'animate.css';
import '@/assets/css/base.scss';
import '@vant/touch-emulator';
createApp(App).use(store).use(router).use(_Tab).use(_Tabs).use(_List).use(_Collapse).use(_CollapseItem).use(_Dialog).mount('#app');